import DLSTextInput from "../../../dls/dls-textInput";
import { IDSSTextInputProps } from "../../DSSFramework";
import { ErrorView } from "../../molecule/error-view";

export const DSSTextInput = ({ value, onChange, label, placeholder, disabled, type, id, name, className, style, startIcon, endIcon, fieldTouched, fieldErrors, maxLength, required, ...props }: IDSSTextInputProps) => {
    return (
        <>
            <DLSTextInput
                id={id}
                placeholder={placeholder}
                name={name}
                value={value}
                onChange={onChange}
                className={className}
                style={style}
                type={type}
                disabled={disabled}
                label={label}
                startIcon={startIcon}
                endIcon={endIcon}
                required={required ?? true}
                maxLength={maxLength}
                // dataTestId={ props.dataTestId ?? id }
                {...props}
            />
            {fieldTouched && fieldErrors && (
                <ErrorView errors={fieldErrors} />
            )}
        </>
    );
};